import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";

import {
  BackgroundBoxA,
  BackgroundBoxB,
  Container,
  Content,
  Illustration,
  IllustrationContainer,
  Link,
  Message,
  Pitch,
  Tagline,
} from "./SectionConversionBlock.styles";

export interface SectionConversionBlockProps
  extends Queries.SanitySectionConversionBlock {}

const SectionConversionBlock: React.FC<SectionConversionBlockProps> = ({
  headline,
  _rawImage,
  image,
  imageAlt,
  pitch,
  _rawPitch,
  tagline,
  button,
}) => (
  <Container>
    <Content>
      {image && (
        <IllustrationContainer>
          <OptimizedImage image={image} alt={imageAlt} />
        </IllustrationContainer>
      )}

      {_rawImage && (
        <IllustrationContainer>
          <Illustration
            src={_rawImage as unknown as string}
            alt={imageAlt as unknown as string}
          />
        </IllustrationContainer>
      )}
      <Message>
        {tagline && <Tagline>{tagline}</Tagline>}
        <Text variant="H3" as="h3">
          {headline}
        </Text>
        {_rawPitch && (
          <Pitch>
            <RichText text={_rawPitch} />
          </Pitch>
        )}

        {pitch && <Pitch>{pitch as unknown as string}</Pitch>}

        {button?.url && button.label && (
          <Link href={button.url}>
            <Button
              label={button.label}
              variant={button.variant as ButtonVariant}
            />
          </Link>
        )}
      </Message>
      <BackgroundBoxA />
      <BackgroundBoxB />
    </Content>
  </Container>
);

export const query = graphql`
  fragment SectionConversionBlock on SanitySectionConversionBlock {
    _key
    _type
    headline
    _rawPitch(resolveReferences: { maxDepth: 5 })
    tagline
    image { ...OptimizedImage }
    imageAlt
    button {
      variant
      label
      url
    }
  }
`;

export default SectionConversionBlock;
